import { render } from "./AssignUserToStore.vue?vue&type=template&id=b97cb968"
import script from "./AssignUserToStore.vue?vue&type=script&lang=js"
export * from "./AssignUserToStore.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__